import { render, staticRenderFns } from "./ContentComponent.vue?vue&type=template&id=9120c62c&scoped=true"
import script from "./ContentComponent.vue?vue&type=script&lang=js"
export * from "./ContentComponent.vue?vue&type=script&lang=js"
import style0 from "./ContentComponent.vue?vue&type=style&index=0&id=9120c62c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9120c62c",
  null
  
)

export default component.exports